import { addMethod, string } from 'yup'
import {
  checkPasswordStrength,
  isPredictablePassword,
} from '@/services/password.service'
import i18n from '@/langs'

addMethod(string, 'passStrength', function () {
  return this.test(
    'passStrength',
    i18n.global.t('validation.password_is_weak'),
    (value) => {
      if (!value) {
        return false
      }

      const strength = checkPasswordStrength(value)
      return strength >= 3
    }
  )
})

addMethod(string, 'alphaNum', function () {
  return this.test(
    'alphaNum',
    i18n.global.t('validation.alpha_num'),
    (value) => {
      return value ? /^[0-9A-Z]*$/iu.test(value) : false
    }
  )
})

addMethod(string, 'passNotPredictable', function () {
  return this.test(
    'passNotPredictable',
    i18n.global.t('validation.password_is_predictable'),
    (value) => {
      if (!value) {
        return false
      }

      return !isPredictablePassword(value)
    }
  )
})
